import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { i18nResources } from './config/languages';
import { getStoredPortalLanguage } from './utils/portalLanguage';

const currentLanguage = getStoredPortalLanguage();

i18n.use(initReactI18next).init({
  resources: i18nResources(),
  lng: currentLanguage,
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

export default i18n;
